export default "/images/vendor/@coreui/icons/svg/flag/cif-pe.svg?ed7f41aa640f805bffe62a9d241d491d";